<template>
  <header class="header">
    <div class="header-content">
      <div class="logo-container">
        <img src="../assets/logo.svg" alt="SYAI Logo" class="logo">
      </div>
      <div class="language-switch" @click="toggleLanguage">
        <span class="lang" :class="{ active: currentLanguage === 'zh' }">中</span>
        <span class="divider">|</span>
        <span class="lang" :class="{ active: currentLanguage === 'en' }">EN</span>
      </div>
    </div>
  </header>
</template>

<script>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: 'Header',
  setup() {
    const { locale } = useI18n()

    const currentLanguage = computed(() => locale.value)

    const toggleLanguage = () => {
      locale.value = locale.value === 'zh' ? 'en' : 'zh'
    }

    return { currentLanguage, toggleLanguage }
  }
}
</script>

<style scoped>
.header {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: #3c93c6;
  z-index: 1000;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

.logo-container {
  /* background-color: rgba(255, 255, 255, 0.2); */
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

.logo-container:hover {
  /* background-color: rgba(255, 255, 255, 0.3);  */
}

.logo {
  height: 30px;
  width: auto;
  display: block;
}

.language-switch {
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 5px 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.language-switch:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.lang {
  color: #ffffff;
  font-size: 14px;
  padding: 0 5px;
  transition: color 0.3s ease;
}

.lang.active {
  color: #e8f4fb;
  font-weight: bold;
}

.divider {
  color: rgba(255, 255, 255, 0.5);
  margin: 0 5px;
}
</style>
